import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ProfileService } from '@app/core/services/profile.service';

export const termsOfUseCompliantGuard: CanActivateFn = (): Observable<boolean> => {
  const profileService = inject(ProfileService);
  const router = inject(Router);
  return profileService.onUser.pipe(
    filter(Boolean),
    map(() => {
      if (profileService.isTermsOfUseCompliant()) {
        return true;
      } else {
        router.navigateByUrl('/terms-of-use');
        return false;
      }
    }),
  );
};
